module.exports = __webpack_public_path__ + "static/basicauth-a178ce74f7ffb408a90275e07d39b4b4.png";